
export function mergeByDocumentId(arrays) {
  try {
    const merged = arrays?.reduce((acc, array) => {
      if (Array.isArray(array)) {
        return acc.concat(array);
      }
      return acc;
    }, []);

    const unique = merged.reduce((acc, current) => {
      const x = acc.find(item => item.documentId === current.documentId);
      if (!x) {
        return acc.concat([current]);
      } else {                
        return acc;
      }   
    }, []);

    return unique;

  } catch (e) {
    return [];
  }
}